import React, { useEffect, useState } from "react";
import Layouts from "../../components/Layouts";
import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { getDirectusClient } from "../../lib/directus";
import { Button, Table, Typography, Card, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { productosfacturaAdd } from "../../features/productosFacrurar/productosSlice";
import { readItems } from "@directus/sdk";

const { Title, Text } = Typography;

function VisualizarFactura(props) {
  let totalfinal = 0;
  const [producutosf, setProductosf] = useState([]);
  const directus = getDirectusClient();

  const location = useLocation();
  const navigate = useNavigate();

  const dispacth = useDispatch();

  const productosfacturar = useSelector((state) => state.productosfacturar);

  const seriales = async (id) => {
    const directus = await getDirectusClient();
    try {
      const response = await directus.request(
        readItems('seriales', {
          fields: ['*'],
          filter: {
            produtofactura: {
              id: {
                _eq: id,
              },
            },
          },
        })
      );
      return response;
    } catch (error) {
      console.error('Error fetching seriales:', error);
      return [];
    }
  };

  const consulta = async () => {
    try {
      const directus = await getDirectusClient();
      const productosPromises = location.state.factura.productos.map(async (producto) => {
        // Get producto_factura details
        const response = await directus.request(
          readItems('productos_factura', {
            fields: ['id', 'nombre', 'cantidad', 'precio_unitario'],
            filter: {
              id: {
                _eq: producto
              }
            }
          })
        );
  
        if (response && response.length > 0) {
          const productoData = response[0];
          // Get seriales for this producto
          const serialesData = await seriales(productoData.id);
          
          return {
            nombre: productoData.nombre,
            id: productoData.id,
            cantidad: productoData.cantidad,
            seriales: serialesData.data,
            preciounitario: productoData.precio_unitario
          };
        }
        return null;
      });
  
      // Wait for all promises to resolve
      const productos = await Promise.all(productosPromises);
      return productos.filter(Boolean); // Remove any null values
    } catch (error) {
      console.error('Error fetching productos:', error);
      return [];
    }
  };

  useEffect(() => {
    const consultardata = async () => {
      try {
        const productos = await consulta();
        setProductosf(productos);
      } catch (error) {
        console.error('Error in consultardata:', error);
        setProductosf([]);
      }
    };
    
    consultardata();
  }, [location.state.factura.productos]);

  const columns = [
    {
      title: 'Producto',
      dataIndex: 'nombre',
      key: 'nombre',
    },
    {
      title: 'Cantidad',
      dataIndex: 'cantidad',
      key: 'cantidad',
    },
    {
      title: 'Precio Unitario',
      dataIndex: 'preciounitario',
      key: 'preciounitario',
      render: (value) => `$${value.toLocaleString()}`,
    },
    {
      title: 'Total Parcial',
      key: 'total',
      render: (_, record) => `$${(record.cantidad * record.preciounitario).toLocaleString()}`
    },
  ];

  const calculateTotal = (data) => {
    return data.reduce((acc, item) => acc + (item.cantidad * item.preciounitario), 0);
  };

  return (
    <Layouts>
      <Card>
        <Space direction="vertical" style={{ width: '100%' }} size="large">
          <Title level={4}>Detalles de Factura</Title>
          
          <Space direction="vertical">
            <Text strong>Factura N°: {location.state.factura.id}</Text>
            <Text>Fecha: {new Date(location.state.factura.date_created).toLocaleDateString()}</Text>
          </Space>

          <Table
            columns={columns}
            dataSource={producutosf}
            pagination={false}
            rowKey="id"
            summary={(pageData) => {
              const total = calculateTotal(pageData);
              return (
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0} colSpan={3}>
                    <Text strong>Total</Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={1}>
                    <Text strong>${total.toLocaleString()}</Text>
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              );
            }}
          />

          <Button
            className="print-no"
            style={{ width: 150 }}
            onClick={() => navigate("/")}
          >
            Volver
          </Button>
        </Space>
      </Card>
    </Layouts>
  );
}

export default VisualizarFactura;
